
import { defineComponent, PropType, ref, computed } from "vue";
import { EditStore } from "@/stores";
import {
  DisplayOrder,
  IOutputStyle,
  OrderStyle,
  OutputType,
  ViewOrder,
  twoBytwoOrder,
  twoBytwoOrderLTRB,
} from "@/services/Models";
import EditDownloadSelectOutputOrder from "@/components/EditDownloadSelectOutputOrder.vue";
import EditDownloadSelectOutputDisplayOrder from "@/components/EditDownloadSelectOutputDisplayOrder.vue";
import EditDownloadSelectOutputOrderStyle from "@/components/EditDownloadSelectOutputOrderStyle.vue";
import EditDownloadSelectOutputSelect from "@/components/EditDownloadSelectOutputSelect.vue";
import { ImageFrame } from "./EditDownload.vue";

export default defineComponent({
  name: "EditDownloadSelectOutput",
  components: {
    EditDownloadSelectOutputOrder,
    EditDownloadSelectOutputDisplayOrder,
    EditDownloadSelectOutputOrderStyle,
    EditDownloadSelectOutputSelect,
  },
  props: {
    size: { type: Object as PropType<{ width: number; height: number }> },
    images: { type: Object as PropType<ImageFrame[]> },
    editStore: { type: Object as PropType<EditStore> },
    outputStyle: { type: Object as PropType<IOutputStyle> },
  },
  setup(props, context) {
    const vAlign = OutputType.vAlign;
    const split = OutputType.split;
    const twoBytwo = OutputType.twoBytwo;
    const splitBySelect = OutputType.splitBySelect;
    const state = ref<IOutputStyle>({
      outputType: props.outputStyle?.outputType ?? OutputType.vAlign,
      selectFrames: props.outputStyle?.selectFrames ?? [],
      twoBytwoOption: props.outputStyle?.twoBytwoOption ?? {
        order: ViewOrder.RTLB, // 右上、右下、左上、左下
        displayOrder: DisplayOrder.none,
        orderStyle: OrderStyle.type1,
      },
    });
    // 特定コマのみ出力で全て未チェックの場合はダウンロードボタンを非活性化
    const isNotSelected = computed(() => {
      return (
        state.value.selectFrames.length == 0 &&
        state.value.outputType == splitBySelect
      );
    });

    const back = () => {
      context.emit("update:outputStyle", state);
      context.emit("back");
    };
    const preview = () => {
      context.emit("update:outputStyle", state);
      context.emit("preview");
    };
    const download = () => {
      context.emit("update:outputStyle", state);
      context.emit("download");
    };
    return {
      state,
      vAlign,
      split,
      twoBytwo,
      splitBySelect,
      back,
      preview,
      download,
      twoBytwoOrder,
      twoBytwoOrderLTRB,
      isNotSelected,
    };
  },
});
